import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { getMobileOS } from "../../../../../utils/detectMobile";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
var getAppImgAlt = function getAppImgAlt(currentDevice) {
  return "\u0421\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u0441\u0138\u0430\u0447\u0438\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 ".concat(currentDevice);
};
export var AppButtonsMobile = /*#__PURE__*/memo(function (_ref) {
  var callback = _ref.callback,
    changeUrl = _ref.changeUrl,
    onMobileDetect = _ref.onMobileDetect,
    device = _ref.device,
    data = _ref.data,
    className = _ref.className;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentDevice = _useState2[0],
    setCurrentDevice = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    rendered = _useState4[0],
    setRendered = _useState4[1];
  var _onClick = useCallback(function (currDevice) {
    if (callback) {
      callback(currDevice);
    }
  }, [callback]);
  var getHref = useCallback(function (name) {
    return rendered && changeUrl ? changeUrl(name, data[name].link) : data[name].link;
  }, [rendered, changeUrl, data]);
  useEffect(function () {
    var initialDevice = device || getMobileOS();
    if (onMobileDetect) {
      onMobileDetect(initialDevice);
    }
    setCurrentDevice(initialDevice);
    setRendered(true);
  }, [device, onMobileDetect]);
  if (!data) {
    return null;
  }
  if (currentDevice) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      className: cn('app-button', className),
      href: getHref(currentDevice),
      onClick: function onClick() {
        return _onClick(currentDevice);
      },
      rel: "noreferrer",
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      alt: getAppImgAlt(currentDevice),
      loading: "lazy",
      src: data[currentDevice].image
    })), currentDevice === 'android' && (data === null || data === void 0 ? void 0 : data.huawei) && /*#__PURE__*/React.createElement("a", {
      className: cn('app-button', className),
      href: data === null || data === void 0 ? void 0 : data.huawei.link,
      onClick: function onClick() {
        return _onClick(currentDevice);
      },
      rel: "noreferrer",
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      alt: getAppImgAlt(currentDevice),
      loading: "lazy",
      src: data === null || data === void 0 ? void 0 : data.huawei.image
    })), (data === null || data === void 0 ? void 0 : data.smartTv) && /*#__PURE__*/React.createElement("a", {
      className: cn('app-button', className),
      href: data.smartTv.link,
      onClick: function onClick() {
        return _onClick(currentDevice);
      },
      rel: "noreferrer",
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      alt: getAppImgAlt(currentDevice),
      loading: "lazy",
      src: data.smartTv.image
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(data).map(function (key, i) {
    return /*#__PURE__*/React.createElement("a", {
      className: cn('app-button', className),
      href: getHref(key),
      key: +i,
      onClick: function onClick() {
        return _onClick(key);
      },
      rel: "noreferrer",
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      alt: getAppImgAlt(key),
      loading: "lazy",
      src: data[key].image
    }));
  }));
});